import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/debateABall/data/constants';

const initState = { currentScreen: SCREENS.LOADING };

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload.screen };

    case REDUX_ACTIONS.INITIALIZE_GAME:
      return { currentScreen: SCREENS.PROGRESS };

    // on end of round, return to Progress Screen
    case REDUX_ACTIONS.ROUND_END: {
      const { isLevelMastered } = payload;
      return {
        currentScreen: isLevelMastered ? SCREENS.VICTORY_SCREEN : SCREENS.PROGRESS,
      };
    }

    // when a round starts, go to the Round Introduction screen
    case REDUX_ACTIONS.ROUND_START:
      return {
        currentScreen: payload.levelIndex === -1 ? SCREENS.STANDARD_VIEW : SCREENS.ROUND_INTRODUCTION,
      };

    default:
      return state;
  }
};

export default screenReducer;
